(function () {
  function activate(section, index) {
    var navItems = section.querySelectorAll('.tl-history__nav-item');
    var navBtns = section.querySelectorAll('[data-tl-history-nav]');
    var cards = section.querySelectorAll('[data-tl-history-card]');

    navItems.forEach(function (item, i) {
      item.classList.toggle('is-active', i === index);
    });

    navBtns.forEach(function (btn) {
      var on = Number(btn.getAttribute('data-tl-history-nav')) === index;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    cards.forEach(function (card) {
      var on = Number(card.getAttribute('data-tl-history-card')) === index;
      card.classList.toggle('is-active', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initSection(section) {
    if (!section || section.dataset.tlHistoryReady === '1') return;
    section.dataset.tlHistoryReady = '1';

    var navBtns = section.querySelectorAll('[data-tl-history-nav]');
    var cards = section.querySelectorAll('[data-tl-history-card]');
    if (!navBtns.length || !cards.length) return;

    navBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(section, Number(btn.getAttribute('data-tl-history-nav')));
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activate(section, Number(card.getAttribute('data-tl-history-card')));
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate(section, Number(card.getAttribute('data-tl-history-card')));
      });
    });

    activate(section, 0);
  }

  function initAll() {
    document.querySelectorAll('[data-tl-history]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-tl-history]')
        : null;
    if (section) {
      section.dataset.tlHistoryReady = '0';
      initSection(section);
    }
  });
})();
